import React, { useState, useEffect } from 'react';
import { Row, Col, Checkbox } from 'antd';
import { ChangeSeatLayout } from '../../change-seat-layout/change-seat-layout.component';
import { ScheduleCalendar } from '../../shared/schedule-calendar/schedule-calendar.component';
import { getAPIDateFormat } from '../../../utils/date.utils';
import { isValid } from '../../../utils/utilities';

export const ScheduleChangeLayout = ({ scheduleData, selectedDate }) => {

    const [currentSelectedDates, setCurrentSelectedDates] = useState([]);
    const [isPermanent, setIsPermanent] = useState(false);
    const [selectedTripIds, setSelectedTripIds] = useState([]);
    const [scheduleTripByDate, setScheduleTripByDate] = useState(null);

    const handlePermanentChange = (e) => {
        setIsPermanent(e.target.checked);
    };

    useEffect(()=>{
        if(scheduleData.trips && isValid(scheduleTripByDate)){
            let passingTrips = [];
            currentSelectedDates.forEach((date)=>{
                if(isValid(scheduleTripByDate[date])){
                    passingTrips.push(scheduleTripByDate[date].id);
                }
            });
            setSelectedTripIds(passingTrips);
        }
    },[currentSelectedDates, scheduleTripByDate, scheduleData.trips]);

    return (
        <div className="change-layout-container">
            <ScheduleCalendar 
                selectedDate={selectedDate}
                onDatesChange={setCurrentSelectedDates}
                showLegend={true}
                scheduleData={scheduleData}
                loadCalendarData={true}
                setScheduleTripByDate={setScheduleTripByDate}
            />

            <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
                <Col span={24}>
                    <Checkbox 
                        checked={isPermanent}
                        onChange={handlePermanentChange}
                    >
                        Make changes permanent
                    </Checkbox>
                </Col>
            </Row>

            
            <ChangeSeatLayout
                tripId={scheduleData.id}
                tripRouteId={null}
                isSchedule={true}
                scheduleBusId={scheduleData.bus_id}
                scheduleParams={{
                    isPermanent: isPermanent,
                    selectedDates: currentSelectedDates,
                    scheduleId: scheduleData.id,
                    selectedTripIds: selectedTripIds
                }}
            />
        </div>
    );
}; 